// Period
export const GET_PERIODS = '/period';
export const GET_PERIOD_QUERY = '/period/query';
export const GET_PERIOD_BY_ID = '/period/';
export const PUT_PERIOD = '/period/';
export const DELETE_PERIOD = '/period/';
